<script setup lang="ts">
import { useDisplay } from 'vuetify';
import ReadMore from '../ReadMore.vue';
import useLocale from '../helpers/use-locale';

type Emits = {
  (e: 'confirmed'): void;
};
const emit = defineEmits<Emits>();

const editedDescription = defineModel<string>();

type Props = {
  canEditDescription?: boolean;
};
withDefaults(defineProps<Props>(), { canEditDescription: false });

const { smAndDown } = useDisplay();
const { t } = useLocale();

const confirmEditingDescription = () => emit('confirmed');
</script>

<template>
  <v-textarea
    v-if="canEditDescription"
    id="input-description-field"
    v-model="editedDescription"
    rows="2"
    :label="editedDescription ? t('components.label_description') : t('components.label_empty_description')"
    clearable
    maxlength="500"
    :no-resize="smAndDown"
    :hide-details="smAndDown"
    variant="solo"
    flat
    counter="500"
    :aria-label="t('components.label_edit_description')"
    aria-describedby="input-description-field"
    @keydown.enter.prevent="confirmEditingDescription"
    @blur="confirmEditingDescription"
  />
  <ReadMore
    v-else
    :html-format="true"
    :more-str="t('components.label_read_more')"
    :less-str="t('components.label_read_less')"
    :text="editedDescription ? editedDescription : t('components.label_empty_description')"
    :max-chars="smAndDown ? 100 : 300"
  >
  </ReadMore>
</template>

<style scoped lang="scss">
:deep(.v-field) {
  &.v-field--focused {
    border: 2px solid rgb(var(--v-theme-primary));
    margin: -2px 0;
  }
}
</style>
